'use client';

import React from 'react';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { EarnAccordionOptions } from 'src/hooks/useEarnProduct';
import { EarnProductMobile } from './EarnProductMobile';
import { EarnProductDesktop } from './EarnProductDesktop';

interface EarnProductComponentProps {
	earnProduct: EarnAccordionOptions;
	showDetails: boolean;
	belongsToLastProductRow: boolean;
	noWrapper?: boolean;
}

export const EarnProductComponent: React.FC<EarnProductComponentProps> = ({
	earnProduct,
	showDetails,
	belongsToLastProductRow,
	noWrapper,
}) => {
	const isMobile = useIsMobileScreenSize();

	if (isMobile) {
		return (
			<EarnProductMobile
				earnProduct={earnProduct}
				showDetails={showDetails}
				noWrapper={noWrapper}
			/>
		);
	}

	return (
		<EarnProductDesktop
			earnProduct={earnProduct}
			showDetails={showDetails}
			belongsToLastProductRow={belongsToLastProductRow}
		/>
	);
};
